import { render } from "./TabPane.vue?vue&type=template&id=419f68fc&scoped=true"
import script from "./TabPane.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPane.vue?vue&type=script&setup=true&lang=js"

import "./TabPane.vue?vue&type=style&index=0&id=419f68fc&scoped=true&lang=scss"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419f68fc"],['__file',"src/components/tabs/TabPane.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "419f68fc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('419f68fc', __exports__)) {
    console.log('reload')
    api.reload('419f68fc', __exports__)
  }
  
  module.hot.accept("./TabPane.vue?vue&type=template&id=419f68fc&scoped=true", () => {
    console.log('re-render')
    api.rerender('419f68fc', render)
  })

}


export default __exports__